export default "__VITE_ASSET__DzfGlAzn__"